import { render, staticRenderFns } from "./LightUgTable.vue?vue&type=template&id=4a1f4cc3&scoped=true"
import script from "./LightUgTable.vue?vue&type=script&lang=ts"
export * from "./LightUgTable.vue?vue&type=script&lang=ts"
import style0 from "./LightUgTable.vue?vue&type=style&index=0&id=4a1f4cc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1f4cc3",
  null
  
)

export default component.exports